import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/site/SmoothScroll";
import Landing from "@/pages/Landing";
import PaymentReturn from "@/pages/PaymentReturn";
import Admin from "@/pages/Admin";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";

function App() {
  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden />
      <BrowserRouter>
        <SmoothScroll>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/payment-return" element={<PaymentReturn />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </SmoothScroll>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
